import _ from 'lodash';

import ReplyView from '@/user/pages/authorized/study/japanese/work/JapaneseReplyView';

import UrlUtility from '@/classes/common/UrlUtility';
import UserWindowSizeUtility from '@/classes/common/UserWindowSizeUtility';


/**
 * 単語データクラス
 */
export default class JapaneseWordData {

  /** 単語データ */
  public word = '';

  /** ルビ */
  public rubi = '';

  /** 下線フラグ */
  public lineFlag = false;

  /** 補正後幅 */
  public w = 0;

  /** 補正後高さ */
  public h = 0;

  /** 回答 */
  public reply: ReplyView | null = null;

  /** 画像 */
  public image: HTMLImageElement | null = null;

  /** フォントサイズ */
  private fontSize = 0;




  /**
   * constructor
   *
   * @param canvasContext
   * @param text
   * @param lineFlag
   * @param fontsizeSmallFlag
   * @param fontSize
   * @param qaImages
   */
  constructor(
    canvasContext: CanvasRenderingContext2D,
    text: string,
    lineFlag: boolean,
    fontsizeSmallFlag: boolean,
    fontSize: number,
    qaImages: {
      url: string,
      image: HTMLImageElement
    }[]
  ) {
    this.lineFlag = lineFlag;
    this.fontSize = fontSize;
    const pos = text.indexOf('(');
    if (pos === -1) {
      this.word = text;
    } else {
      this.word = text.substring(0, pos);
      this.rubi = text.substring(pos + 1, text.length - 1);
    }

    if (this.word.length > 0) {
      // 手書き入力の場合
      if (this.word.charAt(0) === '□') {
        this.reply = new ReplyView(
          canvasContext,
          this.word.length,
          fontsizeSmallFlag
        );
      }

      // 画像の場合
      if (this.word.charAt(0) === '<') {
        const imageUrl = this.word.substring(1, this.word.length - 1);
        this.image = _.find(qaImages, { url: imageUrl })!.image;
      }
    }

    // サイズの計算
    this.calcSize();
  }




  /*
    * サイズを計算します
    */
  public calcSize(): void {
    if (this.reply !== null) {
      this.w = this.reply.width;
      this.h = this.reply.height;
    } else if (this.image !== null) {
      // マスタデータにクエリストリングとして定義された元画像のサイズを調整
      const qs = UrlUtility.getQueryStringObject(this.word.substring(1, this.word.length - 1));
      this.w = UserWindowSizeUtility.calculateRatio(Number(qs.w));
      this.h = UserWindowSizeUtility.calculateRatio(Number(qs.h));
    } else {
      this.w = this.fontSize * 3 / 2; // ルビのぶんを入れる
      this.h = Math.max(this.fontSize * this.word.length, this.fontSize * this.rubi.length / 2);
    }
  }




}
